import { render, staticRenderFns } from "./RelatoTurnoModal.vue?vue&type=template&id=081fb6b0&scoped=true&"
import script from "./RelatoTurnoModal.vue?vue&type=script&lang=js&"
export * from "./RelatoTurnoModal.vue?vue&type=script&lang=js&"
import style0 from "./RelatoTurnoModal.vue?vue&type=style&index=0&id=081fb6b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081fb6b0",
  null
  
)

export default component.exports